// shipping swiper slider

document.addEventListener('DOMContentLoaded', function() {
  let shippingSwipers = [];

  function initShippingSwiper(swiperContainer) {
    var desktop = swiperContainer.data("desktop");
    var largeTablet = swiperContainer.data("large-tablet");
    var tablet = swiperContainer.data("tablet");
    var mobile = swiperContainer.data("mobile");
    var autoplay = swiperContainer.data("autoplay");

    var shippingSwiper = new Swiper(swiperContainer, {
      slidesPerView: desktop,
      spaceBetween: 60,
      autoplay: autoplay,
      grabCursor: true,
      freeMode: false,
      mousewheel: false,
      navigation: {
        nextEl: swiperContainer.find('.shipping-swiper-button-next'),
        prevEl: swiperContainer.find('.shipping-swiper-button-prev'),
      },
      pagination: {
        el: swiperContainer.find(".shipping-swiper-pagination"),
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: mobile,
          spaceBetween: 15,
        },
        576: {
          slidesPerView: tablet,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: largeTablet,
          spaceBetween: 15,
        },
        992: {
          slidesPerView: desktop,
          spaceBetween: 30,
        },
        1100: {
          slidesPerView: desktop,
          spaceBetween: 60,
        },
      },
    });

    shippingSwipers.push(shippingSwiper);
  }

  // Initialize shipping swiper on page load
  $('.Shipping-inner-row').each(function () {
    initShippingSwiper($(this));
  });

  document.addEventListener('shopify:section:select', function () {
    // Reinitialize shipping swiper on section select
    shippingSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    shippingSwipers = [];
    $('.Shipping-inner-row').each(function () {
      initShippingSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:load', function () {
    // Reinitialize shipping swiper on section load
    shippingSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    shippingSwipers = [];
    $('.Shipping-inner-row').each(function () {
      initShippingSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:deselect', function () {
    // Cleanup shipping swiper on section deselect if necessary
    shippingSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    shippingSwipers = [];
  });
});


// testimonial swiper slider

document.addEventListener('DOMContentLoaded', function() {
  let testimonialSwipers = [];

  function initTestimonialSwiper(swiperContainer) {
    var desktop = swiperContainer.data("desktop");
    var tablet = swiperContainer.data("tablet");
    var mobile = swiperContainer.data("mobile");
    var autoplay = swiperContainer.data("autoplay");
    var loop = swiperContainer.data("loop");
    var speed = swiperContainer.data("speed");
    var freemode = swiperContainer.data("freemode");
    var mousewheel = swiperContainer.data("mousewheel");
    
    testi = new Swiper(swiperContainer, {
      spaceBetween: 30,
      freeMode: freemode,
      loop: loop,
      speed: speed,
      autoplay: autoplay,
      mousewheel: mousewheel,
      navigation: {
        nextEl: ".testi-swiper-button-next",
        prevEl: ".testi-swiper-button-prev"
      },
      pagination: {
        el: '.testimonial-swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        320: {
          slidesPerView: mobile,
          spaceBetween: 15
        },
        681: {
          slidesPerView: tablet,
          spaceBetween: 15
        },
        992: {
          slidesPerView: desktop,
          spaceBetween: 30
        },
      }
    });

    testimonialSwipers.push(testi);
  }

  // Initialize testimonial swiper on page load
  $('.testimonial-wrap').each(function() {
    initTestimonialSwiper($(this));
  });

  document.addEventListener('shopify:section:select', function() {
    // Reinitialize testimonial swiper on section select
    testimonialSwipers.forEach(function(swiper) {
      swiper.destroy();
    });
    testimonialSwipers = [];
    $('.testimonial-wrap').each(function() {
      initTestimonialSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:load', function() {
    // Reinitialize testimonial swiper on section load
    testimonialSwipers.forEach(function(swiper) {
      swiper.destroy();
    });
    testimonialSwipers = [];
    $('.testimonial-wrap').each(function() {
      initTestimonialSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:deselect', function() {
    // Cleanup testimonial swiper on section deselect if necessary
    testimonialSwipers.forEach(function(swiper) {
      swiper.destroy();
    });
    testimonialSwipers = [];
  });
});

// tab-product swiper slider
document.addEventListener('DOMContentLoaded', function () {
  let tabSwipers = [];

  function initTabSwiper(swiperContainer) {
    var enable = swiperContainer.data("enable-slider");
    var desktop = swiperContainer.data("desktop");
    var largeTablet = swiperContainer.data("large-tablet");
    var tablet = swiperContainer.data("tablet");
    var mobile = swiperContainer.data("mobile");
    var autoplay = swiperContainer.data("autoplay");
    var loop = swiperContainer.data("loop");
    var speed = swiperContainer.data("speed");
    var slidesPerColumn = swiperContainer.data("slides-column");

      var tabSlider = new Swiper(swiperContainer, {
        slidesPerView: desktop,
        slidesPerColumn: slidesPerColumn,
        spaceBetween: 30,
        observer: true,
        observeParents: true,
        dots: true,
        loop: loop,
        speed: speed,
        autoplay: autoplay,
        pagination: {
          el: swiperContainer.find(".tab-swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: swiperContainer.find('.tab-swiper-button-next'),
          prevEl: swiperContainer.find('.tab-swiper-button-prev'),
        },
        breakpoints: {
          320: {
            slidesPerView: mobile,
            spaceBetween: 15,
            slidesPerColumn: 1,
          },
          576: {
            slidesPerView: tablet,
            spaceBetween: 15,
            slidesPerColumn: 1,
          },
          841: {
            slidesPerView: largeTablet,
            spaceBetween: 15,
            slidesPerColumn: 1,
          },
          992: {
            slidesPerView: desktop,
            spaceBetween: 30,
          },
        },
      });

      tabSwipers.push(tabSlider);
  }

  // Initialize Tab Swiper on page load
  $('.swiper-container#lg-product-tab-slider').each(function () {
    initTabSwiper($(this));
  });

  document.addEventListener('shopify:section:select', function () {
    // Reinitialize Tab Swiper on section select
    tabSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    tabSwipers = [];
    $('.swiper-container#lg-product-tab-slider').each(function () {
      initTabSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:load', function () {
    // Reinitialize Tab Swiper on section load
    tabSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    tabSwipers = [];
    $('.swiper-container#lg-product-tab-slider').each(function () {
      initTabSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:deselect', function () {
    // Cleanup Tab Swiper on section deselect if necessary
    tabSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    tabSwipers = [];
  });
});

// blog swiper slider

document.addEventListener('DOMContentLoaded', function () {
    let blogSwipers = [];

    function initBlogSwiper(swiperContainer) {
        var desktop = swiperContainer.data("desktop");
        var tablet = swiperContainer.data("tablet");
        var mobile = swiperContainer.data("mobile");
        var autoplay = swiperContainer.data("autoplay");
        var loop = swiperContainer.data("loop");
        var speed = swiperContainer.data("speed");
        var freemode = swiperContainer.data("freemode");
        var mousewheel = swiperContainer.data("mousewheel");

        var blogSwiper = new Swiper(swiperContainer, {
            slidesPerView: desktop,
            grabCursor: true,
            freeMode: freemode,
            autoplay: autoplay,
            observer: true,
            observeParents: true,
            spaceBetween: 30,
            loop: loop,
            speed: speed,
            mousewheel: mousewheel,
            keyboard: {
                enabled: true
            },
            pagination: {
                el: swiperContainer.find(".blog-swiper-pagination"),
                clickable: true,
            },
            navigation: {
                nextEl: swiperContainer.find(".swiper-button-next"),
                prevEl: swiperContainer.find(".swiper-button-prev"),
            },
            breakpoints: {
                320: {
                    slidesPerView: mobile,
                    spaceBetween: 15
                },
                480: {
                    slidesPerView: tablet,
                    spaceBetween: 15
                },
                680: {
                    slidesPerView: tablet,
                    spaceBetween: 15
                },
                768: {
                    slidesPerView: tablet,
                    spaceBetween: 15
                },
                992: {
                    slidesPerView: desktop,
                    spaceBetween: 30
                },
            }
        });

        blogSwipers.push(blogSwiper);
    }
    // Initialize blog swiper on page load
    $('.swiper-slider-blog').each(function () {
        initBlogSwiper($(this));
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize blog swiper on section select
        blogSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        blogSwipers = [];
        $('.swiper-slider-blog').each(function () {
            initBlogSwiper($(this));
        });
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup blog swiper on section deselect if necessary
        blogSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        blogSwipers = [];
    });
});


// brand swiper slider

document.addEventListener('DOMContentLoaded', function() {
    let brandSwipers = [];

    function initBrandSwiper(brandContainer) {
        var desktop = brandContainer.data("desktop");
        var largeTablet = brandContainer.data("large-tablet");
        var tablet = brandContainer.data("tablet");
        var mobile = brandContainer.data("mobile");
        var autoplay = brandContainer.data("autoplay");
        var loop = brandContainer.data("loop");
        var speed = brandContainer.data("speed");

        var brandSlider = new Swiper(brandContainer, {
            slidesPerView: 1,
            grabCursor: true,
            freeMode: false,
            autoplay: autoplay,
            observer: true,
            observerParents: true,
            spaceBetween: 160,
            loop: loop,
            speed: speed,
            mousewheel: false,
            navigation: {
                nextEl: brandContainer.find(".brand-swiper-button-next"),
                prevEl: brandContainer.find(".brand-swiper-button-prev"),
            },
            pagination: {
                el: brandContainer.find(".brand-swiper-pagination"),
                clickable: true,
            },
            breakpoints: {
                320: {
                    slidesPerView: mobile,
                    spaceBetween: 30,
                },
                575: {
                    slidesPerView: tablet,
                    spaceBetween: 60,
                },
                767: {
                    slidesPerView: tablet,
                    spaceBetween: 80,
                },
                990: {
                    slidesPerView: largeTablet,
                    spaceBetween: 100,
                },
                1199: {
                    slidesPerView: largeTablet,
                    spaceBetween: 120,
                },
                1429: {
                    slidesPerView: desktop,
                },
            },
        });

        brandSwipers.push(brandSlider);
    }

    // Initialize brand swiper on page load
    $('.brand-slider-section-wrapper').each(function() {
        initBrandSwiper($(this));
    });

    document.addEventListener('shopify:section:select', function() {
        // Reinitialize brand swiper on section select
        brandSwipers.forEach(function(swiper) {
            swiper.destroy();
        });
        brandSwipers = [];
        $('.brand-slider-section-wrapper').each(function() {
            initBrandSwiper($(this));
        });
    });

    document.addEventListener('shopify:section:deselect', function() {
        // Cleanup brand swiper on section deselect if necessary
        brandSwipers.forEach(function(swiper) {
            swiper.destroy();
        });
        brandSwipers = [];
    });
});


// category collection swiper slider

document.addEventListener('DOMContentLoaded', function () {
    let categorySwipers = [];

    function initCategorySwiper(categoryContainer) {
        var desktop = categoryContainer.data("desktop");
        var largeTablet = categoryContainer.data("large-tablet");
        var tablet = categoryContainer.data("tablet");
        var mobile = categoryContainer.data("mobile");
        var autoplay = categoryContainer.data("autoplay");
        var loop = categoryContainer.data("loop");
        var speed = categoryContainer.data("speed");
        var slider = $(".main-collection-list-wrapper").data("slider");
       
          var categorySlider = new Swiper(categoryContainer, {
            slidesPerView: desktop,
            grabCursor: true,
            freeMode: false,
            autoplay: autoplay,
            observer: true,
            observerParents: true,
            spaceBetween: 30,
            loop: loop,
            speed: speed,
            mousewheel: false,
            navigation: {
                nextEl: categoryContainer.find(".cate1-swiper-button-next"),
                prevEl: categoryContainer.find(".cate1-swiper-button-prev"),
            },
            pagination: {
                el: categoryContainer.find(".category-swiper-pagination"),
                clickable: true,
            },
            breakpoints : {
              320: {
                  slidesPerView: mobile,
                  spaceBetween: 15,
              },
              480: {
                  slidesPerView: tablet,
                  spaceBetween: 15,
              },
              576: {
                  slidesPerView: tablet,
                  spaceBetween: 15,
              },
              841: {
                  slidesPerView: largeTablet,
                  spaceBetween: 15,
              },
              992: {
                  slidesPerView: largeTablet,
                  spaceBetween: 30,
              },
              1100: {
                  slidesPerView: desktop,
                  spaceBetween: 30,
              },
            }
        });
      

        categorySwipers.push(categorySlider);
    }

    // Initialize category swiper on page load
    $('.main-collections-list-wrapper').each(function () {
        initCategorySwiper($(this));
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize category swiper on section select
        categorySwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        categorySwipers = [];
        $('.main-collections-list-wrapper').each(function () {
            initCategorySwiper($(this));
        });
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup category swiper on section deselect if necessary
        categorySwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        categorySwipers = [];
    });
});

// category collection style2 swiper slider

document.addEventListener('DOMContentLoaded', function() {
    let categorySwipers = [];

    function initCategorySwiper(swiperContainer) {
        var desktop = swiperContainer.data("desktop");
        var tablet = swiperContainer.data("tablet");
        var largeTablet = swiperContainer.data("large-tablet");
        var mobile = swiperContainer.data("mobile");
        var autoplay = swiperContainer.data("autoplay");
        var loop = swiperContainer.data("loop");
        var speed = swiperContainer.data("speed");

            var category = new Swiper(swiperContainer, {
                slidesPerView: 1,
                spaceBetween: 30,
                autoplay: autoplay,
                grabCursor: true,
                freeMode: false,
                speed: speed,
                loop: loop,
                mousewheel: false,
                navigation: {
                    nextEl: swiperContainer.find(".category3-swiper-button-next"),
                    prevEl: swiperContainer.find(".category3-swiper-button-prev"),
                },
                pagination: {
                    el: swiperContainer.find(".main-collection-list-item-2 .category-swiper-pagination"),
                    clickable: true,
                },
                breakpoints: {
                    320: {
                    slidesPerView: mobile,
                    spaceBetween: 15,
                    },
                    480: {
                        slidesPerView: mobile,
                        spaceBetween: 15,
                    },
                    576: {
                        slidesPerView: tablet,
                        spaceBetween: 15,
                    },
                    841: {
                        slidesPerView: largeTablet,
                        spaceBetween: 15,
                    },
                    992: {
                        slidesPerView: largeTablet,
                        spaceBetween: 30,
                    },
                  1100: {
                        slidesPerView: desktop,
                        spaceBetween: 30,
                    },
                    1200: {
                        slidesPerView: desktop,
                        spaceBetween: 30,
                    },
                },
            });

            categorySwipers.push(category);
    }

    // Initialize category swiper on page load
    $('.category-2-collection').each(function () {
        initCategorySwiper($(this));
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize category swiper on section select
        categorySwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        categorySwipers = [];
        $('.category-2-collection').each(function () {
            initCategorySwiper($(this));
        });
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup category swiper on section deselect if necessary
        categorySwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        categorySwipers = [];
    });
});


// category collection style3 swiper slider

document.addEventListener('DOMContentLoaded', function () {
    let categorySwipers = [];

    function initCategorySwiper(categoryContainer) {
        var desktop = categoryContainer.data("desktop");
        var largeTablet = categoryContainer.data("large-tablet");
        var tablet = categoryContainer.data("tablet");
        var mobile = categoryContainer.data("mobile");
        var autoplay = categoryContainer.data("autoplay");
        var loop = categoryContainer.data("loop");
        var speed = categoryContainer.data("speed");

        var categorySlider = new Swiper(categoryContainer, {
            slidesPerView: desktop,
            grabCursor: true,
            freeMode: false,
            autoplay: autoplay,
            observer: true,
            observerParents: true,
            spaceBetween: 30,
            loop: loop,
            speed: speed,
            mousewheel: false,
            navigation: {
                nextEl: categoryContainer.find(".category-swiper-button-next"),
                prevEl: categoryContainer.find(".category-swiper-button-prev"),
            },
            pagination: {
                el: categoryContainer.find(".category-swiper-pagination"),
                clickable: true,
            },
            breakpoints : {
              320: {
                  slidesPerView: mobile,
                  spaceBetween: 15,
              },
              480: {
                  slidesPerView: tablet,
                  spaceBetween: 15,
              },
              576: {
                  slidesPerView: tablet,
                  spaceBetween: 15,
              },
              768: {
                  slidesPerView: largeTablet,
                  spaceBetween: 15,
              },
              992: {
                  slidesPerView: desktop,
                  spaceBetween: 15,
              },
               1100: {
                  slidesPerView: desktop,
                  spaceBetween: 30,
              },
              1367: {
                  slidesPerView: desktop,
                  spaceBetween: 30,
              },
            }
        });

        categorySwipers.push(categorySlider);
    }

    // Initialize category swiper on page load
    $('.main-collection-list-wrapper3').each(function () {
        initCategorySwiper($(this));
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize category swiper on section select
        categorySwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        categorySwipers = [];
        $('.main-collection-list-wrapper3').each(function () {
            initCategorySwiper($(this));
        });
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup category swiper on section deselect if necessary
        categorySwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        categorySwipers = [];
    });
});



// category collection style4 swiper slider

   document.addEventListener('DOMContentLoaded', function () {
    let categorySwipers = [];

    function initCategorySwiper(categoryContainer) {
        var desktop = categoryContainer.data("desktop");
        var largeTablet = categoryContainer.data("large-tablet");
        var tablet = categoryContainer.data("tablet");
        var mobile = categoryContainer.data("mobile");
        var autoplay = categoryContainer.data("autoplay");
        var loop = categoryContainer.data("loop");
        var speed = categoryContainer.data("speed");

        var categorySlider = new Swiper(categoryContainer, {
            slidesPerView: 1,
            grabCursor: true,
            freeMode: false,
            autoplay: autoplay,
            observer: true,
            observerParents: true,
            spaceBetween: 30,
            loop: loop,
            speed: speed,
            mousewheel: false,
            navigation: {
                nextEl: categoryContainer.find(".cate4-swiper-button-next"),
                prevEl: categoryContainer.find(".cate4-swiper-button-prev"),
            },
            pagination: {
                el: categoryContainer.find(".category-swiper-pagination"),
                clickable: true,
            },
            breakpoints: {
                320: {
                    slidesPerView: mobile,
                    spaceBetween: 15,
                },
                480: {
                    slidesPerView: tablet,
                    spaceBetween: 15,
                },
                681: {
                    slidesPerView: largeTablet,
                    spaceBetween: 15,
                },
                1300: {
                    slidesPerView: desktop,
                    spaceBetween: 30,
                },
            },
        });

        categorySwipers.push(categorySlider);
    }

    // Initialize category swiper on page load
    $('.main-collections-list-wrapper4').each(function () {
        initCategorySwiper($(this));
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize category swiper on section select
        categorySwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        categorySwipers = [];
        $('.main-collections-list-wrapper4').each(function () {
            initCategorySwiper($(this));
        });
    });

    document.addEventListener('shopify:section:load', function () {
        // Reinitialize category swiper on section load
        initCategorySwiper($(this));
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup category swiper on section deselect if necessary
        categorySwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        categorySwipers = [];
    });
});



// main-collection-grid slider
  document.addEventListener('DOMContentLoaded', function () {
    let collectionSwipers = [];

    function initCollectionSwiper(collectionContainer) {
        var enable = collectionContainer.data("enable");
        var desktop = collectionContainer.data("desktop");
        var largeTablet = collectionContainer.data("large-tablet");
        var tablet = collectionContainer.data("tablet");
        var mobile = collectionContainer.data("mobile");
        var autoplay = collectionContainer.data("autoplay");
        var loop = collectionContainer.data("loop");
        var speed = collectionContainer.data("speed");

        if (enable) {
            var collectionSlider = new Swiper(collectionContainer, {
                slidesPerView: 1,
                spaceBetween: 30,
                autoplay: autoplay,
                loop: loop,
                speed: speed,
                freeMode: false,
                mousewheel: false,
                pagination: {
                    el: collectionContainer.find(".swiper-pagination"),
                    clickable: true,
                },
                navigation: {
                    nextEl: collectionContainer.find('.swiper-button-next'),
                    prevEl: collectionContainer.find('.swiper-button-prev'),
                },
                breakpoints: {
                    320: {
                        slidesPerView: mobile,
                        spaceBetween: 15,
                    },
                    480: {
                        slidesPerView: tablet,
                        spaceBetween: 15,
                    },
                    681: {
                        slidesPerView: largeTablet,
                        spaceBetween: 30,
                    },
                    768: {
                        slidesPerView: largeTablet,
                        spaceBetween: 10,
                    },
                    992: {
                        slidesPerView: desktop,
                        spaceBetween: 30,
                    },
                },
            });

            collectionSwipers.push(collectionSlider);
        }
    }

    // Initialize collection swiper on page load
    $('.collection_slider').each(function () {
        initCollectionSwiper($(this));
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize collection swiper on section select
        collectionSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        collectionSwipers = [];
        $('.collection_slider').each(function () {
            initCollectionSwiper($(this));
        });
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup collection swiper on section deselect if necessary
        collectionSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        collectionSwipers = [];
    });
});

// featured collection swiper slider

document.addEventListener('DOMContentLoaded', function () {
    var featuredCollectionSwipers = [];

    function initFeaturedCollectionSwiper(swiperContainer) {
        var desktop = swiperContainer.data("desktop");
        var largeTablet = swiperContainer.data("large-tablet");
        var tablet = swiperContainer.data("tablet");
        var mobile = swiperContainer.data("mobile");
        var autoplay = swiperContainer.data("autoplay");
        var loop = swiperContainer.data("loop");
        var speed = swiperContainer.data("speed");
        var slidesPerColumn = swiperContainer.data("slides-column");

            var featuredCollectionSwiper = new Swiper(swiperContainer, {
                slidesPerView: desktop,
                slidesPerColumn: slidesPerColumn,
                spaceBetween: 30,
                loop: true,
                autoplay: autoplay,
                speed: speed,
                navigation: {
                    nextEl: swiperContainer.find(".featured-swiper-button-next"),
                    prevEl: swiperContainer.find(".featured-swiper-button-prev")
                },
                pagination: {
                    el: swiperContainer.find(".featured-swiper-pagination"),
                    clickable: true,
                },
                breakpoints: {
                    320: {
                        slidesPerView: mobile,
                        spaceBetween: 15,
                       slidesPerColumn: 1
                    },
                    576: {
                        slidesPerView: tablet,
                        spaceBetween: 15,
                       slidesPerColumn: 1
                    },
                    641: {
                        slidesPerView: largeTablet,
                        spaceBetween: 15,
                        slidesPerColumn: 1 
                    },
                    992: {
                        slidesPerView: desktop,
                        spaceBetween: 30
                    },
                },
            });

            featuredCollectionSwipers.push(featuredCollectionSwiper);
    }

    // Initialize Featured Collection Swiper on page load
    $('.featured-swiper').each(function () {
        initFeaturedCollectionSwiper($(this));
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize Featured Collection Swiper on section select
        featuredCollectionSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        featuredCollectionSwipers = [];
        $('.featured-swiper').each(function () {
            initFeaturedCollectionSwiper($(this));
        });
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup Featured Collection Swiper on section deselect if necessary
        featuredCollectionSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        featuredCollectionSwipers = [];
    });
});




// deal of day collection swiper slider

document.addEventListener('DOMContentLoaded', function () {
    var dealCollectionSwipers = [];

    function initFeaturedCollectionSwiper(swiperContainer) {
        var desktop = swiperContainer.data("desktop");
        var largeTablet = swiperContainer.data("large-tablet");
        var tablet = swiperContainer.data("tablet");
        var mobile = swiperContainer.data("mobile");
        var autoplay = swiperContainer.data("autoplay");
        var loop = swiperContainer.data("loop");
        var speed = swiperContainer.data("speed");

            var featuredCollectionSwiper = new Swiper(swiperContainer, {
                slidesPerView: desktop,
                spaceBetween: 30,
                loop: true,
                autoplay: autoplay,
                speed: speed,
                navigation: {
                    nextEl: swiperContainer.find(".deal-swiper-button-next"),
                    prevEl: swiperContainer.find(".deal-swiper-button-prev")
                },
                pagination: {
                    el: swiperContainer.find(".deal-swiper-pagination"),
                    clickable: true,
                },
                breakpoints: {
                    320: {
                        slidesPerView: mobile,
                        spaceBetween: 15
                    },
                    576: {
                        slidesPerView: tablet,
                        spaceBetween: 15
                    },
                    841: {
                        slidesPerView: largeTablet,
                        spaceBetween: 15
                    },
                   992: {
                        slidesPerView: desktop,
                        spaceBetween: 30
                    },
                    1100: {
                        slidesPerView: desktop,
                        spaceBetween: 30
                    },
                },
            });

            dealCollectionSwipers.push(featuredCollectionSwiper);
    }

    // Initialize Featured Collection Swiper on page load
    $('.swiper-container.deal-collection-slider').each(function () {
        initFeaturedCollectionSwiper($(this));
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize Featured Collection Swiper on section select
        dealCollectionSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        dealCollectionSwipers = [];
        $('.swiper-container.deal-collection-slider').each(function () {
            initFeaturedCollectionSwiper($(this));
        });
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup Featured Collection Swiper on section deselect if necessary
        dealCollectionSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        dealCollectionSwipers = [];
    });
});

// Hero slidershow js
document.addEventListener('DOMContentLoaded', function() {
  let slideshowSwipers = [];

  function initslideshowSwiper(swiperContainer) {
    var autoplay = swiperContainer.data("autoplay");
    var speed = swiperContainer.data("speed");
    var slider = swiperContainer.data("slider");
    var loop = swiperContainer.data("loop");
    var breakpoints = {};
    if(slider === 'third_slider'){
      breakpoints = {
        1200: {
          slidesPerView: 3,
          spaceBetween: 30
        },
        991: {
          slidesPerView: 2,
          spaceBetween: 30
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 15
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 10
        }
      };
    }
  if(slider === 'five_slider'){
    breakpoints = {
        1200: {
          slidesPerView: 2,
          spaceBetween: 30
        },
        991: {
          slidesPerView: 2,
          spaceBetween: 15
        },
        768: {
          slidesPerView: 2
        },
        480: {
          slidesPerView: 1
        }
      };
    }
    
    var slideshowSwiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 30,
      autoplay: autoplay,
      loop: loop,
      speed: speed,
      grabCursor: true,
      freeMode: false,
      mousewheel: false,
      navigation: {
        nextEl: swiperContainer.find('.swiper-button-next'),
        prevEl: swiperContainer.find('.swiper-button-prev'),
      },
      pagination: {
        el: swiperContainer.find(".swiper-pagination"),
        clickable: true,
      },
      breakpoints: breakpoints
    });

    slideshowSwipers.push(slideshowSwiper);
  }

  // Initialize slideshow swiper on page load
  $('.classic-container').each(function () {
    initslideshowSwiper($(this));
  });

  document.addEventListener('shopify:section:select', function () {
    // Reinitialize slideshow swiper on section select
    slideshowSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    slideshowSwipers = [];
    $('.classic-container').each(function () {
      initslideshowSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:load', function () {
    // Reinitialize slideshow swiper on section load
    slideshowSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    slideshowSwipers = [];
    $('.classic-container').each(function () {
      initslideshowSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:deselect', function () {
    // Cleanup slideshow swiper on section deselect if necessary
    slideshowSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    slideshowSwipers = [];
  });
});

// mega collection banner swiper slider

document.addEventListener('DOMContentLoaded', function () {
    var featuredCollectionSwipers = [];

    function initFeaturedCollectionSwiper(swiperContainer) {
        var desktop = swiperContainer.data("desktop");
        var largeTablet = swiperContainer.data("large-tablet");
        var tablet = swiperContainer.data("tablet");
        var mobile = swiperContainer.data("mobile");
        var slidesPerColumn = swiperContainer.data("slides-column");
        
            var featuredCollectionSwiper = new Swiper(swiperContainer, {
                slidesPerView: desktop,
                spaceBetween: 30,
                slidesPerColumn: slidesPerColumn,
                loop: true,
                autoplay: true,
                freeMode: true,
                speed: 500,
                breakpoints: {
                    320: {
                        slidesPerView: mobile,
                        spaceBetween: 15,
                        slidesPerColumn: 1,
                    },
                    480: {
                        slidesPerView: tablet,
                        spaceBetween: 15,
                        slidesPerColumn: 1,
                    },
                    841: {
                        slidesPerView: largeTablet,
                        spaceBetween: 15,
                        slidesPerColumn: 1,
                    },
                    992: {
                        slidesPerView: desktop,
                        spaceBetween: 30
                    },
                },
            });

            featuredCollectionSwipers.push(featuredCollectionSwiper);
    }

    // Initialize Featured Collection Swiper on page load
    $('.mega-banner').each(function () {
        initFeaturedCollectionSwiper($(this));
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize Featured Collection Swiper on section select
        featuredCollectionSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        featuredCollectionSwipers = [];
        $('.mega-banner').each(function () {
            initFeaturedCollectionSwiper($(this));
        });
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup Featured Collection Swiper on section deselect if necessary
        featuredCollectionSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        featuredCollectionSwipers = [];
    });
});

// best selling collection swiper slider

document.addEventListener('DOMContentLoaded', function () {
    var BestCollectionSwipers = [];

    function initBestCollectionSwiper(swiperContainer) {
        var desktop = swiperContainer.data("desktop");
        var largeTablet = swiperContainer.data("large-tablet");
        var tablet = swiperContainer.data("tablet");
        var mobile = swiperContainer.data("mobile");
        var autoplay = swiperContainer.data("autoplay");
        var loop = swiperContainer.data("loop");
        var speed = swiperContainer.data("speed");

            var featuredCollectionSwiper = new Swiper(swiperContainer, {
                slidesPerView: desktop,
                spaceBetween: 30,
                loop: true,
                autoplay: autoplay,
                speed: speed,
                navigation: {
                    nextEl: swiperContainer.find(".seller-swiper-button-next"),
                    prevEl: swiperContainer.find(".seller-swiper-button-prev")
                },
                pagination: {
                    el: swiperContainer.find(".seller-swiper-pagination"),
                    clickable: true,
                },
                breakpoints: {
                    320: {
                        slidesPerView: mobile,
                        spaceBetween: 15
                    },
                    576: {
                        slidesPerView: tablet,
                        spaceBetween: 15
                    },
                    641: {
                        slidesPerView: largeTablet,
                        spaceBetween: 15
                    },
                    992: {
                        slidesPerView: desktop,
                        spaceBetween: 30
                    }
                },
            });

            BestCollectionSwipers.push(featuredCollectionSwiper);
    }

    // Initialize Featured Collection Swiper on page load
    $('.swiper-container.bestselling_product').each(function () {
        initBestCollectionSwiper($(this));
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize Featured Collection Swiper on section select
        BestCollectionSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        BestCollectionSwipers = [];
        $('.swiper-container.bestselling_product').each(function () {
            initBestCollectionSwiper($(this));
        });
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup Featured Collection Swiper on section deselect if necessary
        BestCollectionSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        BestCollectionSwipers = [];
    });
});

// mega secion1 swiper slider
document.addEventListener('DOMContentLoaded', function () {
  let MegaSwipers = [];

  function initTabSwiper(swiperContainer) {

      var megaSlider = new Swiper(swiperContainer, {
        slidesPerView: 1,
        slidesPerColumn: 1,
        spaceBetween: 30,
        observer: true,
        observeParents: true,
        dots: true,
        loop: true,
        speed: 500,
        autoplay: true,
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 15,
            slidesPerColumn: 1,
          },
          479: {
            slidesPerView: 2,
            spaceBetween: 15,
            slidesPerColumn: 1,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 15,
            slidesPerColumn: 1,
          },
          992: {
            slidesPerView: 4,
            spaceBetween: 30,
            slidesPerColumn: 1,
          },
          1100: {
            slidesPerView: 1,
            spaceBetween: 30,
            slidesPerColumn: 1,
          },
        },
      });

      MegaSwipers.push(megaSlider);
  }

  // Initialize Tab Swiper on page load
  $('.mega-slider1').each(function () {
    initTabSwiper($(this));
  });

  document.addEventListener('shopify:section:select', function () {
    // Reinitialize Tab Swiper on section select
    MegaSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    MegaSwipers = [];
    $('.mega-slider1').each(function () {
      initTabSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:load', function () {
    // Reinitialize Tab Swiper on section load
    MegaSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    MegaSwipers = [];
    $('.mega-slider1').each(function () {
      initTabSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:deselect', function () {
    // Cleanup Tab Swiper on section deselect if necessary
    MegaSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    MegaSwipers = [];
  });
});


// mega secion2 swiper slider
document.addEventListener('DOMContentLoaded', function () {
  let MegaSwipers = [];

  function initTabSwiper(swiperContainer) {

      var MegaSlider = new Swiper(swiperContainer, {
        slidesPerView: 4,
        slidesPerColumn: 2,
        spaceBetween: 30,
        observer: true,
        observeParents: true,
        dots: true,
        loop: true,
        speed: 500,
        autoplay: true,
        breakpoints: {
          320: {
            slidesPerView: 2,
            spaceBetween: 15,
            slidesPerColumn: 1,
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 15,
            slidesPerColumn: 1,
          },
          641: {
            slidesPerView: 3,
            spaceBetween: 15,
            slidesPerColumn: 1,
          },
          841: {
            slidesPerView: 4,
            spaceBetween: 15,
            slidesPerColumn: 1,
          },
          992: {
            slidesPerView: 4,
            spaceBetween: 30,
            slidesPerColumn: 2,
          },
          1100: {
            slidesPerView: 4,
            spaceBetween: 30,
            slidesPerColumn: 2,
          },
        },
      });

      MegaSwipers.push(MegaSlider);
  }

  // Initialize Tab Swiper on page load
  $('.mega-slider2').each(function () {
    initTabSwiper($(this));
  });

  document.addEventListener('shopify:section:select', function () {
    // Reinitialize Tab Swiper on section select
    MegaSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    MegaSwipers = [];
    $('.mega-slider2').each(function () {
      initTabSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:load', function () {
    // Reinitialize Tab Swiper on section load
    MegaSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    MegaSwipers = [];
    $('.mega-slider2').each(function () {
      initTabSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:deselect', function () {
    // Cleanup Tab Swiper on section deselect if necessary
    MegaSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    MegaSwipers = [];
  });
});